const doc = [({"en":({"adminConstantBedType":({"bed":"Bed", "futon":"Futon", "sofaBed":"Sofa bed"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;